<!--
  @Description: 
  @Author: wang.y 
  @Date: 2024-10-15 
-->
<template>
  <div>
    <div class="main-header">
      <page-header v-if="!shareImg">{{`获取分享二维码和分享链接` | dealLanguage(`Get the QR code and link`)}}</page-header>
      <page-header v-else>请保存分享二维码和分享链接</page-header>
    </div>
    
    <div class="form-view" v-show="!shareImg">
      <Form ref="current-form" :model="currentForm" :rules="ruleValidate">
        <div class="view-title">
          <div class="title">{{'请完善您的资料' | dealLanguage('Please complete your information')}}</div>
          <div class="line"></div>
        </div>
        <FormItem prop="name" :label="'姓名' | dealLanguage('Please fill in your name')">
          <Input type="text" v-model="currentForm.name" :placeholder="'请填写您的姓名'| dealLanguage('Please fill in your name')"></Input>
        </FormItem>
      </Form>
      <div class="btn-wrapper">
        <Button type="primary" @click="handleSubmit" :loading="buttonLoading">
          <span v-if="buttonLoading">{{'请求中' | dealLanguage('Loading')}}</span>
          <span v-else>{{'获取分享码' | dealLanguage('Submit')}}</span>
        </Button>
      </div>
    </div>
    <div class="form-view img-view" v-show="shareImg">
      <div class="order-num">当前渠道订单：{{orderNum}}</div>
      <div class="view-title">
        <div class="title">{{'分享海报图片' | dealLanguage('Share poster images')}}</div>
        <div class="line"></div>
      </div>
      <div class="share-warpper">
        <img :src="shareImg" class="share-img">
        <Button type="primary" @click="saveCode(shareImg, 'share-iamge')">{{'保存分享海报图片' | dealLanguage('Save Picture')}}</Button>
      </div>
      <div class="view-title">
        <div class="title">{{'二维码图片' | dealLanguage('QR code image')}}</div>
        <div class="line"></div>
      </div>
      <div class="share-warpper">
        <img :src="codeImg" class="code-img">
        <Button type="primary" @click="saveCode(codeImg, 'share-qr')">{{'保存二维码图片' | dealLanguage('Save Picture')}}</Button>
      </div>
      <div class="view-title">
        <div class="title">{{'分享链接' | dealLanguage('Share link')}}</div>
        <div class="line"></div>
      </div>
      <div class="share-warpper">
        <p class="share-link">{{shareLink}}</p>
        <Button type="primary" @click="handleCopy(shareLink)">{{'复制分享链接' | dealLanguage('Copy Link')}}</Button>
      </div>
    </div>

    <van-dialog className="loading-dialog" v-model="picLoading" :showConfirmButton="false" :overlay="false" width="120px">
      <van-loading type="spinner" color="#1989fa" />
      <p class="loading-tip">{{'图片生成中' | dealLanguage('Loading')}}</p>
    </van-dialog>

    <div class="temp">
      <div class="container html2canvas-font-container" ref="temp-container">
        <div class="wrapper">
          <img :src="templatePath" class="template-img" v-if="templatePath" />
          <div class="code-img">
            <img :src="codeImg" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getActivityChannel } from '@/service/vbef'
import PageHeader from '@/components/mobile/pageHeader.vue'
import { mapState } from 'vuex'
import filter from 'js/filter'
import QRCode from 'qrcode'
import html2canvas from 'html2canvas'
export default {
  inject: ['login', 'wxShare'],
  metaInfo() {
    return {
      title: filter.dealLanguage('获取分享二维码', 'Obtain the shared QR code'),
    }
  },
  components: {
    PageHeader,
  },
  created() {
    if (this.$route.query.activityid) {
      this.activityId = this.$route.query.activityid
    } else {
      this.activityId = this.$store.state.activityId
    }
  },
  mounted() {
    if (!this.user_key) {
      this.login(this.ininUserInfo)
    } else {
      this.ininUserInfo()
    }
  },
  data() {
    return {
      activityId: '',
      filter,
      buttonLoading: false,
      currentForm: {
        name: '',
      },
      ruleValidate: {
        name: [
          {
            required: true,
            message: filter.dealLanguage('请填写您的姓名', 'Please fill in your name'),
            trigger: 'blur',
          },
        ],
      },
      codeImg: '',
      shareImg: '',
      shareLink: '',
      picLoading: false,
      orderNum: 0
    }
  },
  computed: {
    ...mapState({
      language: (state) => state.language,
      user_key: (state) => state.user_key,
      vbef_path: (state) => state.vbef_path,
    }),
  },
  methods: {
    ininUserInfo() {
      const user = this.$store.state.user
      if (user.name) {
        this.currentForm.name = user.name
        this.getActivityChannel()
      }
    },
    handleSubmit() {
      this.$refs['current-form'].validate((valid) => {
        if (valid) {
          if (!this.user_key) {
            this.login(this.getActivityChannel)
          } else {
            this.getActivityChannel()
          }
        }
      })
    },
    async getActivityChannel() {
      if (this.buttonLoading) return
      this.buttonLoading = true
      this.picLoading = true
      this.currentForm.activityId = this.activityId
      let res = await getActivityChannel(this.currentForm)
      this.buttonLoading = false
      if (res.code == 0) {
        this.orderNum = res.data.orderNum
        this.shareLink = `${this.vbef_path}/signUp?sharechannel=${res.data.channelId}`
        this.wxShare({
          title: filter.dealLanguage('获取门票-2025VB100大会', 'Get tickets-2025VB100 Conference'),
          linkurl: this.shareLink,
        })
        this.templatePath = res.data.actExhibitionDto.templatePath
        QRCode.toDataURL(this.shareLink, { margin: 1, height: 320, width: 320 })
          .then((url) => {
            this.codeImg = url
            this.$nextTick(() => {
              let element = this.$refs['temp-container']
              html2canvas(element, { useCORS: true })
                .then((canvas) => {
                  let imgUrl = canvas.toDataURL('image/png')
                  this.shareImg = imgUrl
                  this.picLoading = false
                })
                .catch((err) => {
                  this.picLoading = false
                  this.$notify(`html2canvas error => ${err}`)
                  console.log(`html2canvas error => ${err}`)
                })
            })
          })
          .catch((err) => {
            this.picLoading = false
            this.$notify(`QRCode.toDataURL error => ${err}`)
            console.log(`QRCode.toDataURL error => ${err}`)
          })
      } else {
        this.picLoading = false
        this.$notify(filter.dealLanguage(res.msg, res.enMsg || res.msg))
      }
    },
    saveCode(imgUrl, name = 'downloaded_pic') {
      // 下载图片
      var link = document.createElement('a')
      link.href = imgUrl
      link.download = name // 设置下载的文件名
      link.click() // 模拟点击，触发下载

      // 清理（可选）
      link.remove()
    },
    handleCopy(value) {
      navigator.clipboard
        .writeText(value)
        .then(() => {
          this.$notify({
            type: 'success',
            message: filter.dealLanguage('已复制到剪贴板', 'copy success'),
          })
        })
        .catch((err) => {
          this.$notify(`copy error => ${err}`)
          console.log(`copy error => ${err}`)
        })
    },
  },
}
</script>
<style lang='stylus' scoped>
@import '~styles/common-m.styl'
@import '~styles/form-view-m.styl'
.order-num
  margin-bottom: .2rem
  font-size 0.32rem
.share-warpper
  padding-bottom 0.4rem
  display flex
  flex-wrap wrap
  flex-direction column
  align-items center
  .share-img
    width 100%
    max-width 9rem
  .code-img
    width 4rem
  .share-link
    width 100%
    padding 0.2rem
    background-color #eee
    color #333
    border-radius 0.1rem
    font-size 0.28rem
    line-height 0.36rem
    word-break break-word
  .ivu-btn
    margin-top 0.3rem
    box-shadow none
    transition all 0.3s
    width 3rem
    height 0.9rem
    font-size 0.28rem
    border-radius 0.22rem
    &.ivu-btn-primary
      color #fff
      background-color #FA5A00
      border-color #FA5A00
      &:hover
        background-color #FF4800
        border-color #FF4800
.temp
  width 0
  height 0
  overflow hidden
  .container
    width 686px
    height 1000px
    font-family 'Noto Sans CJK SC', sans-serif
    background linear-gradient(135deg, #FFD0A9 1%, #EB6F07 100%)
    *
      font-family inherit
    .wrapper
      width 100%
      height 100%
      background-image url('~pic/code-bg.png')
      background-repeat no-repeat
      background-size 100% auto
      background-position bottom
      position relative
      .template-img
        position absolute
        top 0
        left 0
        width 100%
        height 100%
      .code-img
        position absolute
        width 200px
        height 200px
        background #FFFFFF
        border-radius 20px
        padding 20px
        left 25px
        bottom 25px
        img
          width 100%
          height 100%
</style>
